require('../../modules/es.string.starts-with');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'startsWith');
